import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui

import { FormControl, InputLabel, Input } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import Swal from 'sweetalert2';
import { useRouter } from 'src/routes/hooks';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Button from '@mui/material/Button';

import Iconify from 'src/components/iconify';

// import '../../../style.css';
import httpCommon from 'src/http-common';

// ----------------------------------------------------------------------

export default function CompleteToRating({ selectedRowID, closeModalComplete }) {
  const router = useRouter();

  const getId = localStorage.getItem('QRId'); // Id
  const getHsp = localStorage.getItem('Hsp'); // site_cd

  const SelectedUserId = selectedRowID; // UserId

  const [UserDt, setUserDt] = useState([]);

  const [UserDtImg, setUserDtImg] = useState([]);

  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData?.wkr_mst_requestor || '';
  const userdept = UserInfoData?.wkr_mst_dept || '';
  const [ratingValue, setRatingValue] = useState('');
  const [textareaValue, setTextareaValue] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  // Get Api All Data
  useEffect(() => {
    const fetchUserWorkListData = async () => {
      try {
        const response = await httpCommon.get(
          `/CompleteStatus.php?id=${getId}&siteCd=${getHsp}&UserId=${SelectedUserId}`
        );

        if (response.data.status === 'SUCCESS') {
          setUserDt(response.data.data1);
          setUserDtImg(response.data.data2);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId]);

  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  useEffect(() => {
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: SelectedUserId,
      };
      try {
        const response = await httpCommon.post('/getUserWRInfo.php', requestData);

        if (response.data.status === 'SUCCESS') {
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].wkr_mst_phone);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId, SelectedUserId]);

  const selectedSchema = '';

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });
  // console.log("SelectedUserId__",SelectedUserId);
  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, '0');
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, '0');
    const minutes = String(rawDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const handleRatingChange = (event, newValue) => {
    setRatingValue(newValue); // Update the state with the new rating value
  };
  const handleRatingChange2 = (newRating) => {
    setRatingValue(newRating);
  };

  const handleKeyPress = (event, newRating) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleRatingChange2(newRating);
    }
  };
  const handleRatingUpdate = async () => {
    console.log('textareaValue', textareaValue);
    console.log('ratingValue', ratingValue);

    if (ratingValue.toString().trim() === '') {
      setErrorMsg('Please select a rating');
      setTimeout(() => setErrorMsg(''), 5000);
      return;
    }
    if (textareaValue.trim() === '') {
      setErrorMsg('Please enter a reason for cancellation');
      setTimeout(() => setErrorMsg(''), 5000);
      return;
    }

    const requestData = {
      site_cd: getHsp,
      userId: getId,
      RatingVlu: ratingValue,
      RatingNote: textareaValue || '',
      RatingWRNo: UserDt[0].RowID,
    };

    try {
      const response = await httpCommon.post('/WR_insertRating.php', requestData);
      if (response.data.status === 'SUCCESS') {
        closeModalComplete();
        Swal.fire({
          title: 'Rating Status',
          text: 'Rating Update successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            router.push('/dashboard/user/list');
          }
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <FormProvider methods={methods}>
      <Grid container spacing={4} className="RejectStatusCs">
        <Grid xs={12} md={5}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify
                icon="codicon:git-pull-request-new-changes"
                style={{ marginBottom: '-5px' }}
              />{' '}
              Requester Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              <div className="usrFrmFld">
                <FormControl>
                  <InputLabel>Employee ID</InputLabel>
                  <Input type="text" name="name" defaultValue={getId || ''} disabled />
                </FormControl>
              </div>
              {(() => {
                if (Username) {
                  return (
                    <div className="usrFrmFld">
                      <FormControl>
                        <InputLabel>Name</InputLabel>
                        <Input type="text" name="name" defaultValue={Username || ''} disabled />
                      </FormControl>
                    </div>
                  );
                }
                return (
                  <div className="fuWdt">
                    <RHFTextField
                      id="outlined-basic"
                      name="name"
                      label="Name"
                      variant="filled"
                      disabled
                    />
                  </div>
                );
              })()}
              <div>
                {(() => {
                  if (userdept) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Department</InputLabel>
                          <Input
                            type="text"
                            name="department"
                            defaultValue={userdept || ''}
                            disabled
                          />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="department"
                        label="Department"
                        variant="filled"
                        disabled
                      />
                    </div>
                  );
                })()}
              </div>
              <div>
                {(() => {
                  if (phnNo) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Contact No</InputLabel>
                          <Input type="text" name="contactNo" defaultValue={phnNo || ''} disabled />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="contactNo"
                        label="Contact No"
                        variant="filled"
                        disabled
                      />
                    </div>
                  );
                })()}
              </div>
            </Box>
          </Card>
        </Grid>

        <Grid xs={12} md={7}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify icon="grommet-icons:workshop" style={{ marginBottom: '-5px' }} /> Work
              Request Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              <RHFTextField
                name="requestDate"
                variant="filled"
                label="Request Date"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                // value={UserDt[0]?.wkr_mst_org_date.date.split(' ')[0]}
                value={
                  UserDt[0]?.wkr_mst_org_date.date
                    ? formatDate(UserDt[0]?.wkr_mst_org_date.date)
                    : ''
                }
              />

              <RHFTextField
                name="service"
                variant="filled"
                label="Service"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_service || ''}
              />
              <RHFTextField
                name="level"
                variant="filled"
                label="Level"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_location || ''}
              />
              <RHFTextField
                name="location"
                variant="filled"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                label="Room No/Location Description(*Please Specify Block, Level & Location Description) :"
                value={UserDt[0]?.wkr_mst_org_locn || ''}
              />
              <RHFTextField
                name="reqDescriptin"
                variant="filled"
                label="Request Description"
                multiline
                rows={4}
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_wr_descs || ''}
              />
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                <Iconify
                  icon="material-symbols:settings-photo-camera-sharp"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Requested Images
              </Typography>
              <div className="image-grid">
                {UserDtImg?.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.attachment} alt={`Issue ${index + 1}`} className="grid-image" />
                  </div>
                ))}
              </div>
            </Box>
          </Card>
          <Card sx={{ px: 3, pb: 5 }} className="RejInfo">
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify icon="mdi:file-cancel" style={{ marginBottom: '-5px' }} /> Complete
              Information
            </Typography>
            <Box display="flex" flexDirection="column" rowGap={3}>
              <RHFTextField
                name="Order Number"
                variant="filled"
                label="Work Order Number"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wko_mst_wo_no || ''}
              />

              <RHFTextField
                name="Comptby"
                variant="filled"
                label="Complete By"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wko_sts_audit || ''}
              />

              <RHFTextField
                name="workcorr"
                variant="filled"
                label="Work Corrective Action "
                className="wkoDetCorr"
                disabled
                value={UserDt[0]?.wko_det_corr_action || ''}
              />
            </Box>
          </Card>
          <Card sx={{ px: 3, pb: 5 }} className="RejInfo">
            <Typography variant="subtitle2" sx={{ mb: 1, mt: 2 }}>
              <Iconify
                icon="streamline:interface-favorite-like-1-reward-social-up-rating-media-like-thumb-hand"
                style={{ marginBottom: '-5px', marginRight: '5px' }}
              />
              Please enter the rating remarks
            </Typography>
            <Box display="flex" flexDirection="column" rowGap={3}>
              <div className="RtingMain">
                <div className="RatingCls">
                  <div className="rating-stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className="star"
                        // className={`star ${star <= ratingValue ? 'filled' : ''}`}
                        onClick={() => handleRatingChange2(star)}
                        onKeyPress={(e) => handleKeyPress(e, star)}
                        role="button"
                        tabIndex={0}
                        style={{
                          color: star <= ratingValue ? '#faaf00' : '#cad1d7',
                          fontSize: '30px',
                          cursor: 'pointer',
                        }}
                      >
                        &#9733;
                      </span>
                    ))}
                  </div>

                  {/* <textarea
                    value={textareaValue || ''}
                    onChange={(e) => setTextareaValue(e.target.value)}
                    placeholder="Enter a reason for cancellation"
                    rows={10}
                    cols={79}
                    className="customTextarea"
                  /> */}

                  <RHFTextField
                    name="reqDescriptin"
                    variant="filled"
                    label="Enter Rating"
                    multiline
                    rows={4}
                    inputProps={{ className: 'RejinputClass' }}
                    value={textareaValue || ''}
                    onChange={(e) => setTextareaValue(e.target.value)}
                  />

                  {errorMsg && <p className="errormessage">{errorMsg}</p>}
                  <div className="RatingBtn">
                    <Button variant="outlined" color="primary" onClick={handleRatingUpdate}>
                      Service Rating
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}

CompleteToRating.propTypes = {
  selectedRowID: PropTypes.object,
  closeModalComplete: PropTypes.object,
};
